// Marketing attribution for the booking: UTMs, ad click IDs and the HubSpot
// contact ID (added to WhatsApp booking links) from the landing URL.
// (booking_slug is the booked location, set on submit.) Kept in
// sessionStorage so it survives the multi-step flow. The latest landing URL
// that carries campaign values (UTMs or a click ID) replaces the whole set,
// so a new ad visit in the same tab is never hidden by an older one; a URL
// without them keeps what's stored. Values are stored exactly as received —
// never a "(direct)" style placeholder.

const STORAGE_KEY = "t2d_attribution";

// URL query param -> field sent with the booking
const URL_PARAMS = {
  utm_source: "utm_source",
  utm_medium: "utm_medium",
  utm_campaign: "utm_campaign",
  utm_content: "utm_content",
  utm_term: "utm_term",
  gclid: "gclid",
  gbraid: "gbraid",
  wbraid: "wbraid",
  fbclid: "fbclid",
  msclkid: "msclkid",
  hs_contact_id: "hubspot_contact_id",
};

function read() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function write(value) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (e) {
    // Private mode / storage blocked: attribution is best effort
  }
}

// Who the visitor is, not where they came from: kept across campaigns
const IDENTITY_FIELDS = ["hubspot_contact_id"];

// Call on app start with the landing URL's query string.
export function captureAttribution({ search = "" } = {}) {
  const query = new URLSearchParams(search);
  const found = {};
  Object.entries(URL_PARAMS).forEach(([param, field]) => {
    const value = query.get(param);
    if (value) found[field] = value;
  });
  if (!Object.keys(found).length) return;

  const stored = read();
  const campaign = Object.keys(found).some((field) => !IDENTITY_FIELDS.includes(field));
  // A new campaign replaces the old one as a set (never mixes the two)
  const next = campaign
    ? Object.fromEntries(IDENTITY_FIELDS.filter((f) => stored[f]).map((f) => [f, stored[f]]))
    : { ...stored };
  write({ ...next, ...found });
}

// Only the known fields, so a value left in storage by an older version of
// the app is never sent
export function getAttribution() {
  const stored = read();
  const attribution = {};
  Object.values(URL_PARAMS).forEach((field) => {
    if (stored[field]) attribution[field] = stored[field];
  });
  return attribution;
}
